<template>
  <el-breadcrumb separator="/">
    <el-breadcrumb-item
      v-for="(item) in breadList"
      :key="item.name"
      :to="{ path: item.path === '' ? '/' : item.path}"
    >{{ item.meta.title }}</el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
export default {
  name: 'Breadcrumb',
  data() {
    return {
      breadList: [],
    };
  },
  created() {
    this.getBreadcrumb();
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    },
  },
  methods: {
    getBreadcrumb() {
      this.breadList = [];
      this.$route.matched.forEach((item) => {
        /*
          如不需要根路径可修改如下:
          item.name !== 'index' && item.meta && item.meta.title)
        */
        if (item.meta && item.meta.title) {
          this.breadList.push(item);
        }
      });
    },
  },
};
</script>
